import { Component, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';  // 引入 CommonModule
import { RouterModule } from '@angular/router';  // 引入 RouterModule
import { AiCustomerServiceComponent } from '../ai-customer-service/ai-customer-service.component';

@Component({
  selector: 'app-layout-full',
  standalone: true,  // 標明這是一個 standalone 組件
  templateUrl: './layout-full.component.html',
  styleUrl: './layout-full.component.scss',
  imports: [CommonModule, RouterModule, AiCustomerServiceComponent]  // 加入 AI 客服組件
})
export class LayoutFullComponent implements OnInit {

    constructor(
    ) {}

  ngOnInit(): void {

  }

}
